export default __webpack_public_path__ + "assets/images/5b85828c24be675a365ebdd14ec50970.png";